import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file ReplaceTrigger.ts
 * @author markJia(markjia@tencent.com)
 */
import React, { useCallback } from 'react';
import { useUpload } from '@tencent/glue-react-upload';
import { DEFAULT_TRIGGER_STYLE } from '../FileTrigger';
export var ReplaceTrigger = function ReplaceTrigger(props) {
  var children = props.children,
      id = props.id,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      style = props.style;
  var upload = useUpload();
  var replaceHandle = useCallback(function (e) {
    e.stopPropagation();

    if (!id) {
      console.error('replace id 为空, 无法触发文件替换');
      return;
    }

    upload.replaceById(id);
  }, [id]);
  return React.createElement("div", {
    onClick: replaceHandle,
    className: className,
    style: _objectSpread(_objectSpread({}, DEFAULT_TRIGGER_STYLE), style)
  }, children);
};